import { styleConstants } from '@paywithextend/components'
import { css } from 'styled-components'

export default css`
  &.ReportTransactionsBoxAndLinks .table {
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-bottom-left-radius: ${styleConstants.borderRadius.box};
    border-bottom-right-radius: ${styleConstants.borderRadius.box};
    overflow: hidden;
  }

  &.ReportTransactionsBoxAndLinks.fullScreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 7;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  &.ReportTransactionsBoxAndLinks.fullScreen .table {
    flex: 1;
    min-height: 0;
  }
`
